/*
* Palo Alto Theme — UMAI custom JS.
*
* This file is loaded on EVERY page from layout/theme.liquid (once — the second
* <script> line down there is inside a Liquid comment and never renders).
*
* 2026-09-07 (Ryan): rewritten. What used to live here was a "featured
* collection" marquee bound to
*   #FeaturedCollection--template--18475710283910__section_collection_9xqiax
* — a homepage section id that is (a) disabled in templates/index.json and
* (b) from a template id the store stopped rendering long ago. It matched
* nothing on any page, on dev or live, and returned at its first null check.
* Deleted rather than repaired: if that marquee is ever wanted again it belongs
* in the section that renders the carousel, not in a global file.
*
* In its place is the scroll-to-top arrow, which now HAS to live here — see
* below. Keep this file loaded.
*/

(function () {
  /* SCROLL-TO-TOP ARROW (moved here from theme.js, 2026-09-07, Ryan).
     layout/theme.liquid renders the button when settings.show_scroll_to_top is
     on, and custom.css styles `.btn--scroll-top` + `.btn--scroll-top.is-visible`.
     The behaviour used to come from assets/theme.js — but theme.js is no longer
     loaded on index/product/collection/search/cart (see umai_js_free_templates
     in the layout), and it was the ONLY thing theme.js still did on those pages.
     Without this port the arrow never gets `is-visible` and sits invisible for
     ever, which is why theme.js could be dropped at all.

     Ported 1:1 from theme.js so the two agree if a template ever goes back to
     loading it: same class name, same `pageYOffset > innerHeight` threshold,
     same smooth scroll, same ~150 ms throttle on the scroll listener. */
  var btn = document.querySelector('[data-scroll-top-button]');
  if (!btn) return;

  var VISIBLE = 'is-visible';
  var ticking = false;

  function sync() {
    ticking = false;
    btn.classList.toggle(VISIBLE, window.pageYOffset > window.innerHeight);
  }

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    setTimeout(sync, 150);
  }, { passive: true });

  /* Deep links and back/forward restores can land mid-page before the first
     scroll event, so set the initial state rather than waiting for one. */
  sync();
})();
